<app-pias-layout>
  <div pias-layout-content>
    <br>
    <div class="header-section">
      <h4 class="mat-h1">Campaign</h4>
      <div class="header-actions">
        <button mat-flat-button color="primary" (click)="newCampaign()">
          <mat-icon>add</mat-icon> Create Campaign
        </button>
      </div>
    </div>
    <!-- <div class="stats-grid">

          <mat-card class="stat-card">
            <mat-card-content>
              <div class="stat-icon-wrap blue">
                <mat-icon>group</mat-icon>
              </div>
              <p class="stat-label">Total Applicants</p>
              <h2 class="stat-value">25</h2>
            </mat-card-content>
          </mat-card>

          <mat-card class="stat-card">
            <mat-card-content>
              <div class="stat-icon-wrap orange">
                <mat-icon>schedule</mat-icon>
              </div>
              <p class="stat-label">Scheduled</p>
              <h2 class="stat-value">2</h2>
            </mat-card-content>
          </mat-card>

          <mat-card class="stat-card">
            <mat-card-content>
              <div class="stat-icon-wrap green">
                <mat-icon>check_circle</mat-icon>
              </div>
              <p class="stat-label">Completed</p>
              <h2 class="stat-value">15</h2>
            </mat-card-content>
          </mat-card>

          <mat-card class="stat-card">
            <mat-card-content>
              <div class="stat-icon-wrap grey"> 
                <mat-icon>event</mat-icon>
              </div>
              <p class="stat-label">Draft</p>
              <h2 class="stat-value">8</h2>
            </mat-card-content>
          </mat-card>

        </div> -->
    <!-- <br> -->
    <div class="campaign-wrapper">
      @if(this.setSprinner()) {
      <div class="pias-spinner">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      }

      <!-- <div class="search-section">
    <div class="table-toolbar">
              <div id="agent-onboard-filter-form" class="w-100">
                <form class="row align-items-start">
                  <div class="col-sm-12 col-md-7 col-lg-5 col-xxl-5 m-0">
                    <div class="position-relative" style="max-width: 500px">
                      <input type="text" class="form-control border-0 shadow-sm ps-5 pe-5"
                        style="background: #f0f0f0; color: #1c3a7a" formControlName="searchApplicants"
                        (keyup)="applyFilter($event)" placeholder="Search" />

                      
                      <i class="fas fa-search position-absolute top-50 start-0 ms-3 translate-middle-y"
                        style="color: #888888"></i>

                     
                      <button type="button" 
                        class="btn position-absolute top-50 end-0 translate-middle-y me-3 p-0 border-0 bg-transparent"
                        (click)="clearSearch()">
                        <i class="fas fa-times" style="color: #888888"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
  </div> -->

      <div class="mat-elevation-z2 table-container">
        <table mat-table [dataSource]="dataSource">

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Campaign Name </th>
            <td mat-cell *matCellDef="let element">
              <div class="name-cell">
                <span class="main-name">{{element.name}}</span>
                <!-- <span class="sub-text"><mat-icon inline>email</mat-icon> {{element.channel}}</span> -->
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="channel">
            <th mat-header-cell *matHeaderCellDef> Channel </th>
            <td mat-cell *matCellDef="let element">
              <div class="channel-icon">
                @if (element.channel === 'email') {
                <mat-icon>email</mat-icon>
                } @else {
                <mat-icon>chat</mat-icon>
                }
                {{element.channel}}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> Status </th>
            <td mat-cell *matCellDef="let element">
              <div class="status-stack">
                <span class="custom-badge" [ngClass]="element.status.toLowerCase()">
                  {{element.status}}
                </span>
                <span class="status-date"
                  *ngIf="element.status.toLowerCase() === 'canceled' || element.status.toLowerCase() === 'scheduled'">{{
                  element.scheduledTime | date:'dd/MM/yyyy, h:mm a':'+0800' }}</span>
                <span class="status-date" *ngIf="element.status.toLowerCase() === 'completed'"> {{ element.updatedAt |
                  date:'dd/MM/yyyy, h:mm a':'+0800' }} </span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="recipients">
            <th mat-header-cell *matHeaderCellDef> Recipients </th>
            <td mat-cell *matCellDef="let element"> {{element.totalRecipients}} </td>
          </ng-container>

          <ng-container matColumnDef="success">
            <th mat-header-cell *matHeaderCellDef> Success </th>
            <td mat-cell *matCellDef="let element">
              <span class="success-count">{{element.successCount}}</span>
              <span class="error-count"> / {{element.failureCount}}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Actions </th>
            <td mat-cell *matCellDef="let element">
              <button mat-stroked-button color="primary" (click)="onViewDetails(element)">
                View Details <mat-icon>chevron_right</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <!-- <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Select page"></mat-paginator> -->
      </div>
    </div>
  </div>
</app-pias-layout>